import { SlotGame } from "@nolimitcity/slot-game/bin/SlotGame";
import { FlowStateController } from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";

import {
    EventsManager,
    GameEvents,
    ReelsEvents,
    WinEvents,
} from "../../../abstracts/events/EventsManager";
import { AbstractFlowPresentation } from "../../../abstracts/flow/AbstractFlowStatePresentation";
import { AbstractGameMode } from "../../../abstracts/flow/AbstractGameMode";
import { fadeAndStopSound } from "../../../abstracts/utils/SoundUtils";
import { UgliestCatch } from "../../UgliestCatch";
import { UCSoundNames } from "../../assetsLoader/UCAssetsNames";
import UCReel from "../../modules/Reels/UCReel";
import { UCReelsView } from "../../modules/Reels/UCReelsView";
import { UCWinView } from "../../modules/Winnings/UCWinView";
import { alreadyOpenedReels } from "./UCFreespinWinPresentation";

export class UCFreespinIdlePresentation extends AbstractFlowPresentation {
    protected winView: UCWinView;
    protected reelsView: UCReelsView;
    protected ucReels: UCReel[];
    // protected openedReelsCount: number = 3;

    // protected fsMultiplier: UCFreespinMultiplier;

    constructor(id: string = `UCFreespinIdlePresentation`) {
        super(id);
    }

    protected handleEvents() {
        super.handleEvents();

        EventsManager.on(WinEvents.GET_WINNINGS_VIEW, (winningsView: UCWinView) => {
            this.winView = winningsView;
        });

        EventsManager.on(ReelsEvents.GET_REELS, (reels: UCReel[]) => {
            this.ucReels = reels;
        });

        EventsManager.on(ReelsEvents.GET_REELS_VIEW, (reelsView: UCReelsView) => {
            this.reelsView = reelsView;
        });
    }

    protected get gameMode(): AbstractGameMode {
        // ! ce-i asta?!
        return AbstractGameMode.FREESPIN;
    }

    protected onIntroScreenComplete() {
        this.keypad.setZeroBetSpinCounter(UgliestCatch.model.data.freespinsLeft);
        this.showFastSpinButton();

        this.keypad.setWin(
            this.model.data.accumulatedRoundWin,
            true,
            UgliestCatch.model.isWinBelowStake()
        );

        // this.keypad.setWin(-1);

        this.finishPresentation();

        EventsManager.trigger(GameEvents.ON_FREE_BETS_START);
    }

    protected finishController() {
        // gsap.delayedCall(0, () => {
        SlotGame.apiPlugin.betHandler.zeroBet();
        super.finishController();
        // });
    }

    public override start(flowStateController: FlowStateController) {
        super.start(flowStateController);

        EventsManager.trigger(GameEvents.HIDE_XBET_BUTTON);
        EventsManager.trigger(GameEvents.DISABLE_IDLE_ANIMATIONS);

        // alreadyOpenedReels.count = 3;

        /*     alreadyOpenedReels.count = this.ucReels.filter(
            (reel) => reel.topBlocker.state === BlockerStates.OPEN
        ).length;*/

        alreadyOpenedReels.count = UgliestCatch.model.data.extraPositionsOpen.filter(
            (isOpen) => isOpen
        ).length;
    }

    protected override onRestoreStart() {
        super.onRestoreStart();
        this.hideFastSpinButton();

        this.reelsView.updateBoatSkinToFS();

        this.winView.showFreespinRestoreScreen(
            this.model.initData.freespinsLeft,
            this.onIntroScreenComplete.bind(this),
            this.model.initData.mode === AbstractGameMode.SUPER_FREESPIN
        );

        this.reelsView.getBoatProgressionAnimation(this.model.data.fishermanProgression, true);

        if (this.model.data.enhancedBet) {
            EventsManager.trigger(GameEvents.CHECK_XBET_ON_RESTORE);
        }

        if (UgliestCatch.model.data.extraPositionsOpen.includes(true)) {
            this.model.data.reels.forEach((reel: string[], reelIndex: number) => {
                if (UgliestCatch.model.data.extraPositionsOpen[reelIndex]) {
                    this.ucReels[reelIndex].topBlocker.open(true);
                    this.ucReels[reelIndex].bottomBlocker.open(true);
                }
            });
        }

        const isWinBeloWStake = UgliestCatch.model.isWinBelowStake(true);

        this.keypad.setWin(
            isWinBeloWStake ? -1 : this.model.initData.accumulatedRoundWin,
            true,
            UgliestCatch.model.isWinBelowStake(isWinBeloWStake)
        );

        return;
    }

    protected onDefaultStart() {
        super.onDefaultStart();

        // const currentOpenedReelsCount = UgliestCatch.model.gameData.extraPositionsOpen.filter(
        //     (isOpen) => isOpen
        // ).length;

        if (
            this.model.data.mode !== AbstractGameMode.FREESPIN &&
            this.model.data.nextMode === AbstractGameMode.FREESPIN
        ) {
            this.keypad.setWin(-1, true, true, true);
            this.hideFastSpinButton();

            // if (this.model.data.mode === AbstractGameMode.NORMAL) {
            //     fadeAndStopSound({
            //         name: this.getPreviousModeSoundName(),
            //         duration: 0.5,
            //         to: 0,
            //     });
            // }

            fadeAndStopSound({
                name: UCSoundNames.MAIN_MUSIC,
                duration: 0.5,
                from: 1,
                to: 0,
            });

            this.winView.showFreespinIntroScreen(
                this.onIntroScreenComplete.bind(this),
                this.model.data.freespinsLeft
            );

            this.reelsView.updateBoatSkinToFS();

            // if (this.model.gameData.mode === AbstractGameMode.NORMAL) {
            //     this.openedReelsCount = currentOpenedReelsCount;
            // }
        } else {
            // if (this.openedReelsCount === 3 && currentOpenedReelsCount === 4) {
            //     this.openedReelsCount = 4;
            //
            //     this.flowPresentationTimeline.add(this.winView.showHawkSpinsScreen());
            // }

            this.flowPresentationTimeline.resume();
        }
    }
}
